/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PublicService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns string
     * @throws ApiError
     */
    public appControllerGetSwaggerJson(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/public/swagger',
        });
    }

}
